import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { inject } from '@angular/core';
import { SITES_BUILDER_AUTH_SESSION } from '../../auth-session';

const vwApi: string = environment.apiUrl;
const authorizedApiBases = [
  environment.apiUrl,
  environment.amenityApi.baseUrl,
  environment.contentUploaderApi.baseUrl,
] as const;

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const authSession = inject(SITES_BUILDER_AUTH_SESSION);
  let request = resolveRequest(req);
  const authorization = authSession.getAuthorizationHeader();

  if (
    authorization &&
    !request.headers.has('Authorization') &&
    isAuthorizedApiRequest(request.url)
  ) {
    request = request.clone({
      setHeaders: { Authorization: authorization },
    });
  }

  return next(request);
};

/** Comprueba una URL absoluta contra las APIs que aceptan la sesión administrativa. */
export function isAuthorizedApiRequest(requestUrl: string): boolean {
  const request = parseHttpUrl(requestUrl);
  if (!request) return false;

  return authorizedApiBases.some((rawBase) => {
    const base = parseHttpUrl(rawBase);
    if (!base || request.origin !== base.origin) return false;

    const basePath = base.pathname === '/' ? '/' : base.pathname.replace(/\/+$/, '');
    return (
      basePath === '/' ||
      request.pathname === basePath ||
      request.pathname.startsWith(`${basePath}/`)
    );
  });
}

/** Conserva recursos externos y prefija únicamente endpoints relativos de la API. */
function resolveRequest(req: HttpRequest<unknown>): HttpRequest<unknown> {
  if (
    parseHttpUrl(req.url) ||
    req.url.includes('/assets/') ||
    req.url.includes('demo')
  ) {
    return req;
  }

  const base = vwApi.replace(/\/+$/, '');
  const path = req.url.replace(/^\/+/, '');
  return req.clone({ url: `${base}/${path}` });
}

/** Parsea exclusivamente URLs HTTP(S) sin credenciales embebidas. */
function parseHttpUrl(raw: string): URL | undefined {
  try {
    const parsed = new URL(raw);
    if (
      (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') ||
      parsed.username ||
      parsed.password
    ) {
      return undefined;
    }
    return parsed;
  } catch {
    return undefined;
  }
}
